import { app } from '../../../../bootstrap/core';
import { waitForTransferringState } from './waitForTransferring.state';
import { waitForTransferringComponent } from './waitForTransferring.component';

import './ibanValidation/ibanValidation';

app.config(waitForTransferringState);
app.component(waitForTransferringComponent.name, waitForTransferringComponent);
